var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"box"}},[_c('h1',[_vm._v("进入量表评估系统")]),_c('el-button',{attrs:{"type":"success"},on:{"click":_vm.goToAssessment}},[_vm._v("点击进入")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }